var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 7,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.9314C32 18.3256 32 18.0226 31.8802 17.8824C31.7763 17.7607 31.6203 17.6961 31.4608 17.7086C31.2769 17.7231 31.0627 17.9373 30.6343 18.3657L27 22L30.6343 25.6343C31.0627 26.0627 31.2769 26.2769 31.4608 26.2914C31.6203 26.3039 31.7763 26.2393 31.8802 26.1176C32 25.9774 32 25.6744 32 25.0686V18.9314Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.8C12 18.1198 12 17.2798 12.327 16.638C12.6146 16.0735 13.0735 15.6146 13.638 15.327C14.2798 15 15.1198 15 16.8 15H22.2C23.8802 15 24.7202 15 25.362 15.327C25.9265 15.6146 26.3854 16.0735 26.673 16.638C27 17.2798 27 18.1198 27 19.8V24.2C27 25.8802 27 26.7202 26.673 27.362C26.3854 27.9265 25.9265 28.3854 25.362 28.673C24.7202 29 23.8802 29 22.2 29H16.8C15.1198 29 14.2798 29 13.638 28.673C13.0735 28.3854 12.6146 27.9265 12.327 27.362C12 26.7202 12 25.8802 12 24.2V19.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidIcon);
export default __webpack_public_path__ + "static/media/vid-icon.3a9270eae9bef49f5d0e74c14b522112.svg";
export { ForwardRef as ReactComponent };